<template>
  <div>
    <el-alert type="info" :closable="false">
      <div slot="title" class="flex flex-wrap p-t-10" style="font-size: 14px;">
        <span
          class="m-r-30 m-b-10"
        >订单编号：{{ orderData.orderCode || '-' }}</span>
        <span
          class="m-r-30 m-b-10"
        >采购数量：{{ strToThousands(orderData.count || 0) }}</span>
        <span
          class="m-r-30 m-b-10"
        >订单总额(元)：{{ strToThousands(orderData.totalPrice || 0) }}</span>
        <span
          class="m-r-30 m-b-10"
        >供货供应商：{{ orderData.supplierName || '-' }}</span>
        <span
          class="m-r-30 m-b-10"
        >联系人：{{ orderData.contactUserName || '-' }}</span>
        <span
          class="m-r-30 m-b-10"
        >联系电话：{{ orderData.contactUserPhone || '-' }}</span>
        <span
          class="m-b-10"
        >邮箱：{{ orderData.contactUserEmail || '-' }}</span>
      </div>
    </el-alert>

    <material-item-table
      :table-list="tableList"
      :table-config-fun="() => tableOption"
      table-id="tempCode"
      :show-operation="false"
      pagination
      disabled
    />
  </div>
</template>

<script>
// 组件
import MaterialItemTable from '@/components/common/MaterialComponent/MaterialItemTable'

// 工具函数
import { strToThousands } from '@/utils/utils'

export default {
  name: 'ItemTable',

  components: {
    MaterialItemTable
  },

  props: {
    orderData: {
      type: Object,
      default: () => {
        return {}
      }
    },

    tableList: {
      type: Array,
      default: () => []
    },

    /**
     * 是否前端分页
     */
    pagination: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      pageTableList: [],
      page: 1,
      size: 20,

      strToThousands
    }
  },

  computed: {
    totalPage() {
      return Math.ceil(this.tableList.length / this.size)
    },

    tableOption() {
      return [
        { label: '申请单编码', prop: 'requirementCode', minWidth: 100 },
        { label: '品目编码', prop: 'itemCode', minWidth: 100 },
        { label: '品目名称', prop: 'itemName', minWidth: 100 },
        { label: '数量', prop: 'itemNum' },
        { label: '参数型号', prop: 'itemModel', minWidth: 100 },
        { label: '品牌/制造商', prop: 'itemBrand', minWidth: 100 },
        { label: '单位', prop: 'itemUnit' },
        {
          label: '含税单价(元)',
          prop: 'priceIncludingTax',
          minWidth: 120,
          filter: value => (value ? strToThousands(value) : '-')
        },
        { label: '税率 %', prop: 'taxRate' },
        {
          label: '不含税单价(元)',
          prop: 'price',
          minWidth: 120,
          filter: value => (value ? strToThousands(value) : '-')
        },
        {
          label: '不含税总价(元)',
          prop: 'totalPrice',
          filter: value => (value ? strToThousands(value) : '-'),
          minWidth: 120
        },
        { label: '供货时间(天)', prop: 'supplyTime', minWidth: 120 },
        {
          label: '收货人',
          prop: '',
          filter: value =>
            `${value.consigneeName || '-'} ${value.consigneePhone || '-'}`,
          minWidth: 200
        },
        { label: '交货地点', prop: 'deliveryAddress', minWidth: 200 }
      ]
    }
  }
}
</script>
